// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.board-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 32px;
}

.board-card {
  background-color: var(--surface-raised);
  border-radius: var(--radius-md);
  padding: 28px;
  text-align: center;
  box-shadow: var(--shadow-soft);
}

.board-photo {
  width: 140px;
  height: 140px;
  margin: 0 auto 20px;
  border-radius: 50%;
  overflow: hidden;
  background-color: var(--surface-sunken);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid var(--color-green);
}

.board-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.board-photo-placeholder {
  color: var(--text-primary);
  font-weight: 600;
}

.board-title {
  color: var(--text-accent);
  font-weight: 600;
  margin: 4px 0 12px;
}

.board-bio {
  font-size: 0.95rem;
  opacity: 0.85;
}

.bio-cont {
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/WhoWeAre.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".board-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 32px;\n}\n\n.board-card {\n  background-color: var(--surface-raised);\n  border-radius: var(--radius-md);\n  padding: 28px;\n  text-align: center;\n  box-shadow: var(--shadow-soft);\n}\n\n.board-photo {\n  width: 140px;\n  height: 140px;\n  margin: 0 auto 20px;\n  border-radius: 50%;\n  overflow: hidden;\n  background-color: var(--surface-sunken);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 3px solid var(--color-green);\n}\n\n.board-photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.board-photo-placeholder {\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n.board-title {\n  color: var(--text-accent);\n  font-weight: 600;\n  margin: 4px 0 12px;\n}\n\n.board-bio {\n  font-size: 0.95rem;\n  opacity: 0.85;\n}\n\n.bio-cont {\n  margin-top: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
